module.exports = __webpack_public_path__ + "static/media/zhengs2-1@2x.19de157d.png";